import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {DirectivesModule} from '../../../../directives/directives.module';
import {FinalReportComponent} from './final-report.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {TdoControlsModule} from '../../../../tdo-controls/tdo-controls.module';
import {FormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {MatRadioModule} from '@angular/material/radio';

@NgModule({
  declarations: [
    FinalReportComponent
  ],
  exports: [
    FinalReportComponent
  ],
  imports: [
    CommonModule,
    DirectivesModule,
    MatCheckboxModule,
    TdoControlsModule,
    FormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatRadioModule
  ]
})
export class FinalReportModule { }
